const menus = [
  { path: "/", name: "home" },
  { path: "/ysts", name: "ysts" },
  { path: "/qyfz", name: "qyfz" },
  { path: "/pygn", name: "pygn" },
  { path: "/dfts", name: "dfts" },
  { path: "/pyms", name: "pyms" },
  { path: "/pyzz", name: "pyzz" },
  { path: "/pyby", name: "pyby" },
  { path: "/gczp", name: "gczp" },
  { path: "/pyyz", name: "pyyz" },
  { path: "/yjzx", name: "yjzx" },
  { path: "/about", name: "about" }
];

export default menus;
